module.exports = __webpack_public_path__ + "img/qufu-name-2.f57f480f.png";